import { DOMAINS } from '../gen/lang.js';

const findDeploymentEnvFromUrl = () => {
    const hostName = window.location.hostname;
    const WWW_DOMAINS = DOMAINS.map((h) => `www.${h}`);
    if (DOMAINS.includes(hostName) ||
        WWW_DOMAINS.includes(hostName)) {
        return 'prod';
    }
    if (hostName.startsWith('test.')) {
        return 'test';
    }
    switch (hostName) {
        case hostName.match(/local/)?.input:
            return 'local';
        case hostName.match(/release/)?.input:
            return 'release';
        case hostName.match(/beta-www/)?.input:
            return 'beta';
        default:
            return 'dev';
    }
};
const findStageFromUrl = () => {
    const env = findDeploymentEnvFromUrl();
    return env === 'beta' || env === 'prod' ? 'prod' : 'dev';
};
const findCDNBaseUrlFromUrl = () => {
    return getCDNBaseUrl(findStageFromUrl());
};
const CDN_DEV_URL = 'https://cdn-dev.public.zooplus.net';
const CDN_PROD_URL = 'https://cdn.public.zooplus.net';
const getCDNBaseUrl = (stage) => {
    return stage === 'dev' ? CDN_DEV_URL : CDN_PROD_URL;
};

export { CDN_DEV_URL, CDN_PROD_URL, findCDNBaseUrlFromUrl, findDeploymentEnvFromUrl, findStageFromUrl, getCDNBaseUrl };
//# sourceMappingURL=envService.js.map
